import { Modal } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getConfig } from '../../../utils/config';
import { objectToSearchParams } from '../../../utils/object-to-searchparams';
import { TATabs } from '../styles';
import { CandidateToJobForm } from './candidate-to-job-form';
import { JobToCandidateForm } from './job-to-candidate-form';

const configService = getConfig();
export const MatchModalFormType = {
	ctoj: 'ctoj',
	jtoc: 'jtoc'
};

export const MatchModalForm = ({ visible, onCancel }) => {
	const candidateFormRef = React.createRef<any>();
	const jobFormRef = React.createRef<any>();
	const [activeTab, setActiveTab] = useState(MatchModalFormType.ctoj);
	const navigate = useNavigate();
	const onSubmit = values => {
		values.type = activeTab;
		navigate({ pathname: configService.URIs.matching_results_uri, search: objectToSearchParams(values) });
		onCancel();
		resetFields();
	};
	const resetFields = () => {
		if (activeTab === MatchModalFormType.ctoj) candidateFormRef.current.resetFields();
		else if (activeTab === MatchModalFormType.jtoc) jobFormRef.current.resetFields();
	};
	return (
		<Modal
			title="Find a Match!"
			visible={visible}
			onCancel={() => {
				resetFields();
				onCancel();
			}}
			okText="Submit"
			onOk={() => {
				if (activeTab === MatchModalFormType.ctoj) candidateFormRef.current.submit();
				else if (activeTab === MatchModalFormType.jtoc) jobFormRef.current.submit();
			}}
		>
			<TATabs centered animated onChange={t => setActiveTab(t)}>
				<TATabs.TabPane tab="Candidate to Job" key={MatchModalFormType.ctoj}>
					<CandidateToJobForm ref={candidateFormRef} onSubmit={onSubmit} />
				</TATabs.TabPane>
				<TATabs.TabPane tab="Job to Candidate" key={MatchModalFormType.jtoc}>
					<JobToCandidateForm ref={jobFormRef} onSubmit={onSubmit} />
				</TATabs.TabPane>
			</TATabs>
		</Modal>
	);
};
